export const formatDate = (date) => {
    const publishDate = new Date(date).toUTCString().split(" ");
    return `${publishDate[2]} ${publishDate[1]}, ${publishDate[3]}`;
};

export function parseDateTime(date) {
    const dateStr = new Date(date).toUTCString().split(" ");
    function getMonthNumber(StringMonth, defaultDate = "1,2022") {
        return (
            new Date(Date.parse(`${StringMonth} ${defaultDate}`)).getMonth() + 1
        );
    }

    return `${dateStr[3]}-${getMonthNumber(dateStr[2])}-${dateStr[1]}`;
}
